import { createAction, props } from '@ngrx/store';
import { RecruiterLeadInfoStatus } from 'src/app/lead-queue/models/recruiter-lead-Info.model';
import { DashboardLead } from 'src/app/recruiting/candidates/details/models/dashboard-lead.model';
import { HotCandidate } from 'src/app/recruiting/candidates/details/models/hot-candidate.model';
import { HotItems } from 'src/app/recruiting/candidates/details/models/hot-items.model';
import { LiveCandidateDetails } from 'src/app/recruiting/candidates/details/models/live-candidate-details.model';
import { LiveCandidateItems } from 'src/app/recruiting/candidates/details/models/live-candidate-item.model';
import {
    PreStartCandidate,
    PreStartItems
} from 'src/app/recruiting/candidates/details/models/prestart-candidate.model';
import {
    SelfApplyCandidates,
    SelfApplyFilter
} from 'src/app/workforce-disruption/shared/models/self-apply-candidate.model';
import { WorkingCandidate, WorkingItems } from 'src/app/recruiting/candidates/details/models/working-candidate.model';
import { DashboardFlyoutData } from 'src/app/recruiting/dashboard/models/dashboard-flyout-data.model';
import { JobInterest, JobInterestGroup } from 'src/app/recruiting/dashboard/models/job-interest.model';
import { DashboardTileFollowups } from 'src/app/shared/models/dashboard-tile-followups.model';

export const showHideFlyout = createAction('[Dashboard Component] Show/Hide Flyout', props<DashboardFlyoutData>());

export const startStopTimer = createAction('[Dashboard Component] Start/Stop Timer', props<{ runTimer: boolean }>());

export const dashboardGetHotCandidates = createAction(
    '[Dashboard Component API] Get Hot candidates',
    props<{ recruiterId: number; maxItems: number; refOnly: boolean }>()
);

export const dashboardGetHotCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Hot candidates success',
    props<{ hots: HotItems }>()
);

export const dashboardGetHotCandidatesFail = createAction(
    '[Dashboard Component API] Get Hot candidates fail',
    props<{ error: string }>()
);

export const dashboardGetAllHotCandidates = createAction(
    '[Dashboard Component API] Get All Hot candidates',
    props<{ recruiterId: number; maxItems: number; refOnly: boolean }>()
);

export const dashboardGetAllHotCandidatesSuccess = createAction(
    '[Dashboard Component API] Get All Hot candidates success',
    props<{ hots: HotItems }>()
);

export const dashboardGetAllHotCandidatesFail = createAction(
    '[Dashboard Component API] Get All Hot candidates fail',
    props<{ error: string }>()
);

export const dashboardGetPendingHotCandidates = createAction(
    '[Dashboard Component API] Get Pending Hot candidates',
    props<{ recruiterId: number; maxItems: number; refOnly: boolean }>()
);

export const dashboardGetPendingHotCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Pending Hot candidates success',
    props<{ hots: HotItems }>()
);

export const dashboardGetPendingHotCandidatesFail = createAction(
    '[Dashboard Component API] Get Pending Hot candidates fail',
    props<{ error: string }>()
);

export const dashboardGetHotDetails = createAction(
    '[Dashboard Component API] Get Hot candidate details',
    props<{ candidateId: number }>()
);

export const dashboardGetHotDetailsSuccess = createAction(
    '[Dashboard Component API] Get Hot candidate details success',
    props<{ hotDetail: HotCandidate }>()
);

export const dashboardGetHotDetailsFail = createAction(
    '[Dashboard Component API] Get Hot candidate details fail',
    props<{ error: string }>()
);

export const dashboardGetLiveCandidates = createAction(
    '[Dashboard Component API] Get Live candidates',
    props<{ recruiterId: number; maxItems: number }>()
);

export const dashboardGetLiveCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Live candidates success',
    props<{ lives: LiveCandidateItems }>()
);

export const dashboardGetLiveCandidatesFail = createAction(
    '[Dashboard Component API] Get Live candidates fail',
    props<{ error: string }>()
);

export const dashboardGetAllLiveCandidates = createAction(
    '[Dashboard Component API] Get All Live candidates',
    props<{ recruiterId: number }>()
);

export const dashboardGetAllLiveCandidatesSuccess = createAction(
    '[Dashboard Component API] Get All Live candidates success',
    props<{ lives: LiveCandidateItems }>()
);

export const dashboardGetAllLiveCandidatesFail = createAction(
    '[Dashboard Component API] Get All Live candidates fail',
    props<{ error: string }>()
);

export const dashboardGetLiveDetails = createAction(
    '[Dashboard Component API] Get Live details',
    props<{ candidateId: number }>()
);

export const dashboardGetLiveDetailsSuccess = createAction(
    '[Dashboard Component API] Get Live details success',
    props<{ details: LiveCandidateDetails }>()
);

export const dashboardGetLiveDetailsFail = createAction(
    '[Dashboard Component API] Get Live details fail',
    props<{ error: string }>()
);

export const dashboardGetPreCandidates = createAction(
    '[Dashboard Component API] Get Pre candidates',
    props<{ recruiterId: number; maxItems: number }>()
);

export const dashboardGetPreCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Pre candidates success',
    props<{ items: PreStartItems }>()
);

export const dashboardGetPreCandidatesFail = createAction(
    '[Dashboard Component API] Get Pre candidates fail',
    props<{ error: string }>()
);

export const dashboardGetAllPreCandidates = createAction(
    '[Dashboard Component API] Get All Pre candidates',
    props<{ recruiterId: number }>()
);

export const dashboardGetAllPreCandidatesSuccess = createAction(
    '[Dashboard Component API] Get All Pre candidates success',
    props<{ data: PreStartItems }>()
);

export const dashboardGetAllPreCandidatesFail = createAction(
    '[Dashboard Component API] Get All Pre candidates fail',
    props<{ error: string }>()
);

export const dashboardGetPreDetails = createAction(
    '[Dashboard Component API] Get Pre details',
    props<{ candidateId: number }>()
);

export const dashboardGetPreDetailsSuccess = createAction(
    '[Dashboard Component API] Get Pre details success',
    props<{ data: PreStartCandidate }>()
);

export const dashboardGetPreDetailsFail = createAction(
    '[Dashboard Component API] Get Pre details fail',
    props<{ error: string }>()
);

export const dashboardGetWorCandidates = createAction(
    '[Dashboard Component API] Get Wor candidates',
    props<{ recruiterId: number; maxItems: number }>()
);

export const dashboardGetWorCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Wor candidates success',
    props<{ items: WorkingItems }>()
);

export const dashboardGetWorCandidatesFail = createAction(
    '[Dashboard Component API] Get Wor candidates fail',
    props<{ error: string }>()
);

export const dashboardGetAllWorCandidates = createAction(
    '[Dashboard Component API] Get All Wor candidates',
    props<{ recruiterId: number }>()
);

export const dashboardGetAllWorCandidatesSuccess = createAction(
    '[Dashboard Component API] Get All Wor candidates success',
    props<{ data: WorkingItems }>()
);

export const dashboardGetAllWorCandidatesFail = createAction(
    '[Dashboard Component API] Get All Wor candidates fail',
    props<{ error: string }>()
);

export const dashboardGetWorDetails = createAction(
    '[Dashboard Component API] Get Wor details',
    props<{ candidateId: number }>()
);

export const dashboardGetWorDetailsSuccess = createAction(
    '[Dashboard Component API] Get Wor details success',
    props<{ data: WorkingCandidate }>()
);

export const dashboardGetWorDetailsFail = createAction(
    '[Dashboard Component API] Get Wor details fail',
    props<{ error: string }>()
);

export const dashboardGetJobInterest = createAction(
    '[Dashboard Component API] Get JobInterest',
    props<{ recruiterId: number }>()
);

export const dashboardGetJobInterestSuccess = createAction(
    '[Dashboard Component API] Get JobInterest success',
    props<{ data: JobInterest[] }>()
);

export const dashboardGetJobInterestFail = createAction(
    '[Dashboard Component API] Get JobInterest fail',
    props<{ error: string }>()
);

export const showJobInterestFlyout = createAction(
    '[Dashboard Component] Show Job Interest Flyout',
    props<{ data: JobInterestGroup[] }>()
);

export const showJobInterestDetailsFlyout = createAction(
    '[Dashboard Component] Show Job Interest Details Flyout',
    props<{ data: JobInterestGroup }>()
);

export const dashboardRemoveJobInterest = createAction(
    '[Dashboard Component] Remove Job Interest From List',
    props<{ data: number }>()
);

export const dashboardGetAllLeadCandidates = createAction(
    '[Dashboard Component API] Get All Lead candidates',
    props<{ recruiterId: number }>()
);

export const dashboardGetAllLeadCandidatesSuccess = createAction(
    '[Dashboard Component API] Get All Lead candidates success',
    props<{ leads: DashboardLead[] }>()
);

export const dashboardGetAllLeadCandidatesFail = createAction(
    '[Dashboard Component API] Get All Lead candidates fail',
    props<{ error: string }>()
);

export const dashboardGetTileFollowups = createAction(
    '[Dashboard Component API] Get Tile Followups',
    props<{ recruiterId: number }>()
);

export const dashboardGetTileFollowupsSuccess = createAction(
    '[Dashboard Component API] Get Tile Followups success',
    props<{ data: DashboardTileFollowups }>()
);

export const dashboardGetTileFollowupsFail = createAction(
    '[Dashboard Component API] Get Tile Followups fail',
    props<{ error: string }>()
);

export const dashboardGetSelfApplyCandidates = createAction(
    '[Dashboard Component API] Get Self Apply candidates',
    props<{ recruiterId: number; filter: SelfApplyFilter }>()
);

export const dashboardGetSelfApplyCandidatesSuccess = createAction(
    '[Dashboard Component API] Get Self Apply candidates success',
    props<{ selfApplyCandidates: SelfApplyCandidates }>()
);

export const dashboardGetSelfApplyCandidatesFail = createAction(
    '[Dashboard Component API] Self Apply candidates fail',
    props<{ error: string }>()
);

export const dashboardGetAllSelfApplyCandidates = createAction(
    '[Dashboard Component API] Get ALL Self Apply candidates',
    props<{ recruiterId: number; filter: SelfApplyFilter }>()
);

export const dashboardGetAllSelfApplyCandidatesSuccess = createAction(
    '[Dashboard Component API] Get ALL Self Apply candidates success',
    props<{ selfApplyCandidates: SelfApplyCandidates }>()
);

export const dashboardGetAllSelfApplyCandidatesFail = createAction(
    '[Dashboard Component API] ALL Self Apply candidates fail',
    props<{ error: string }>()
);

export const dashboardGetRecruiterLeadQueueStatus = createAction(
    '[Dashboard Component API] Get recruiter lead queue pause status',
    props<{ recruiterId: number }>()
);

export const dashboardGetRecruiterLeadQueueStatusSuccess = createAction(
    '[Dashboard Component API] Get recruiter lead queue pause status success',
    props<{ recruiterLeadInfoStatus: RecruiterLeadInfoStatus }>()
);

export const dashboardGetRecruiterLeadQueueStatusFail = createAction(
    '[Dashboard Component API] Get recruiter lead queue pause status fail',
    props<{ error: string }>()
);

export const dashboardUpdateRecruiterLeadQueueStatus = createAction(
    '[Dashboard Component API] Update recruiter lead queue status',
    props<{ leadInfoId: number; status: number }>()
);

export const dashboardUpdateRecruiterLeadQueueStatusSuccess = createAction(
    '[Dashboard Component API] Update recruiter lead queue status success',
    props<{ recruiterLeadInfoStatus: RecruiterLeadInfoStatus }>()
);

export const dashboardUpdateRecruiterLeadQueueStatusFail = createAction(
    '[Dashboard Component API] Update recruiter lead queue status fail',
    props<{ error: string }>()
);
